import React from "react";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import MessageInput from "../MessageInput";
import DraftInput from "../DraftInput";
import TicketAiReportPanel from "../TicketAiReportPanel";
import { i18n } from "../../translate/i18n";

const AntTabs = withStyles({
	root: {
		borderBottom: "0px solid #e8e8e8",
		padding: 0,
		margin: 0,
		border: 0,
		minHeight: "0.5em",
	},
	indicator: {
		backgroundColor: "#1890ff",
	},
})(Tabs);

const AntTab = withStyles((theme) => ({
	root: {
		textTransform: "none",
		minWidth: 72,
		fontWeight: theme.typography.fontWeightRegular,
		marginRight: theme.spacing(4),
		fontFamily: [
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			"Roboto",
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		"&:hover": {
			color: "#40a9ff",
			opacity: 1,
		},
		"&$selected": {
			color: "#1890ff",
			fontWeight: theme.typography.fontWeightMedium,
		},
		"&:focus": {
			color: "#40a9ff",
		},
		fontSize: "0.8em",
		padding: 0,
		margin: 0,
		border: 0,
		minHeight: "0.5em",
	},
	selected: {},
}))((props) => <Tab disableRipple {...props} />);

export default function CustomizedTabs(props) {
	const {
		ticketId,
		ticketStatus,
		ticketChannel,
		ticketOwnerId,
		templateBarStatus,
		ticket,
		tailwickLayout = false,
		composerTab,
		onComposerTabChange,
		messagePrivate,
		hasAiReports = false,
	} = props;

	const isControlled = typeof composerTab === "number";
	const [internalTab, setInternalTab] = React.useState(0);
	const value = isControlled ? composerTab : internalTab;

	const setTab = (newValue) => {
		if (!isControlled) {
			setInternalTab(newValue);
		}
		onComposerTabChange?.(newValue);
	};

	const handleChange = (event, newValue) => {
		setTab(newValue);
	};

	const handleTailwickTabChange = (newValue) => {
		setTab(newValue);
	};

	const renderComposer = () => {
		if (value === 1) {
			return <DraftInput ticketId={ticketId} tailwickLayout={tailwickLayout} />;
		}
		if (value === 2) {
			return (
				<TicketAiReportPanel
					ticketId={ticketId}
					tailwickLayout={tailwickLayout}
				/>
			);
		}
		return (
			<MessageInput
				tailwickLayout={tailwickLayout}
				ticketStatus={ticketStatus}
				ticketChannel={ticketChannel}
				ticketOwnerId={ticketOwnerId}
				templateBarStatus={templateBarStatus}
				ticket={ticket}
				whatsappId={ticket?.whatsappId}
				ticketId={ticketId}
			/>
		);
	};

	return (
		<div
			className={tailwickLayout ? "tailwick-chat-input-area" : undefined}
			style={
				tailwickLayout
					? undefined
					: {
						margin: "0 auto",
						background: "transparent",
						width: "100%",
						maxWidth: "100%",
						boxSizing: "border-box",
						flexShrink: 0,
					}
			}
		>
			{tailwickLayout ? (
				<div
					className="tailwick-composer-tabs"
					role="tablist"
					aria-label={i18n.t("messagesInput.composerTabsLabel")}
				>
					<button
						type="button"
						role="tab"
						aria-selected={value === 0}
						className={clsx(
							"tailwick-composer-tabs__btn",
							value === 0 && "tailwick-composer-tabs__btn--active"
						)}
						onClick={() => handleTailwickTabChange(0)}
					>
						{i18n.t("messagesInput.composerTabReply")}
					</button>
					<button
						type="button"
						role="tab"
						aria-selected={value === 1}
						className={clsx(
							"relative tailwick-composer-tabs__btn",
							value === 1 && "tailwick-composer-tabs__btn--active"
						)}
						onClick={() => handleTailwickTabChange(1)}
					>
						{messagePrivate && (
							<span className="absolute top-0 right-0 h-1.5 w-1.5 rounded-full bg-green-500" />
						)}
						{i18n.t("messagesInput.composerTabPrivate")}
					</button>
					<button
						type="button"
						role="tab"
						aria-selected={value === 2}
						className={clsx(
							"relative tailwick-composer-tabs__btn",
							value === 2 && "tailwick-composer-tabs__btn--active"
						)}
						onClick={() => handleTailwickTabChange(2)}
					>
						{hasAiReports && (
							<span className="absolute top-0 right-0 h-1.5 w-1.5 rounded-full bg-violet-500" />
						)}
						{i18n.t("messagesInput.composerTabAiReport")}
					</button>
				</div>
			) : (
				<div style={{ width: "100%", maxWidth: 420, marginBottom: 12 }}>
					<AntTabs
						value={value}
						onChange={handleChange}
						aria-label={i18n.t("messagesInput.composerTabsLabel")}
						variant="scrollable"
						scrollButtons="auto"
					>
						<AntTab label={i18n.t("messagesInput.composerTabReply")} />
						<AntTab label={i18n.t("messagesInput.composerTabPrivate")} />
						<AntTab label={i18n.t("messagesInput.composerTabAiReport")} />
					</AntTabs>
				</div>
			)}
			<div>{renderComposer()}</div>
		</div>
	);
}
